import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ProyectosService } from '../../../services/proyectos.service';

@Component({
  selector: 'app-aeropuerto',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './aeropuerto.html',
  styleUrl: './aeropuerto.css'
})
export class AeropuertoComponent implements OnInit {
  proyectosRecomendados: any[] = [];

  constructor(private proyectosService: ProyectosService) {}

  ngOnInit() {
    this.proyectosRecomendados = this.proyectosService.getProyectosAleatorios('/proyectos/aeropuerto');
  }
}
